import { atom } from "jotai";
import type { PopupProps } from "./Popup.d";

export const popupAtom = atom<PopupProps[]>([]);